var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-stepper",
    {
      staticClass: "my-3 pt-2 arrow-stepper",
      attrs: { value: _vm.statusNumber, "alt-labels": "" }
    },
    [
      _c(
        "v-stepper-header",
        [
          _c(
            "v-stepper-step",
            {
              staticClass: "py-0",
              attrs: { step: "1", complete: _vm.statusNumber > 1 }
            },
            [_vm._v("\n      Scheduled\n    ")]
          ),
          _vm._v(" "),
          _c("v-divider", { class: { completed: _vm.statusNumber > 1 } }),
          _vm._v(" "),
          _c(
            "v-stepper-step",
            {
              staticClass: "py-0",
              attrs: { step: "2", complete: _vm.statusNumber > 2 }
            },
            [_vm._v("\n      In Transit\n    ")]
          ),
          _vm._v(" "),
          _c("v-divider", { class: { completed: _vm.statusNumber > 2 } }),
          _vm._v(" "),
          _c(
            "v-stepper-step",
            {
              staticClass: "py-0",
              attrs: { step: "3", complete: _vm.statusNumber == 3 }
            },
            [_vm._v("\n      Delivered\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14ff1d0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14ff1d0a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressArrows2.vue
// module id = null
// module chunks = 